import get from 'lodash.get';
import createCachedSelector from 're-reselect';

import { emptyArray, emptyObject } from 'ui-components/default-props/empty';
import { selectFulfillmentPlans } from './fulfillment-plans';

const selectLoading = (state) => get(state, 'loading', emptyObject);
const selectLoadingSalesOrder = (state, props) => get(selectLoading(state, props), 'salesOrders', emptyObject);

export const selectSalesOrderIsLoading = (state, props) => get(selectLoadingSalesOrder(state, props), [props.salesOrderId], false);
export const selectSalesOrders = (state) => get(state, 'salesOrders', emptyObject);
export const selectSalesOrderById = (state, props) => get(selectSalesOrders(state, props), props.salesOrderId);
export const selectSalesOrderProperty = (state, props) => get(selectSalesOrderById(state, props), props.property);

export const selectSalesOrdersByIds = createCachedSelector(
  selectSalesOrders,
  (_, { salesOrderIds }) => JSON.stringify(salesOrderIds),
  (salesOrders, salesOrderIdsJSON) => {
    const salesOrderIds = JSON.parse(salesOrderIdsJSON);

    if (salesOrderIds.length === 0) {
      return emptyArray;
    }

    return salesOrderIds.map((salesOrderId) => salesOrders[salesOrderId]);
  },
)((_, { salesOrderIds }) => JSON.stringify(salesOrderIds));

export const selectSalesOrderIdsByFulfillmentPlanIds = createCachedSelector(
  selectFulfillmentPlans,
  (_, props) => JSON.stringify(props?.fulfillmentPlanIds || []),
  (fulfillmentPlans, fulfillmentPlanIdsJSON) => {
    const fulfillmentPlanIds = JSON.parse(fulfillmentPlanIdsJSON);
    const salesOrderIds = fulfillmentPlanIds.reduce((acc, fulfillmentPlanId) => {
      const { salesOrdersFulfilledIds = [] } = fulfillmentPlans[fulfillmentPlanId] || {};

      salesOrdersFulfilledIds.forEach((salesOrderId) => acc.add(salesOrderId));

      return acc;
    }, new Set());

    if (salesOrderIds.size === 0) {
      return emptyArray;
    }

    return [...salesOrderIds];
  },
)((_, props) => JSON.stringify(props?.fulfillmentPlanIds || []));

export const selectSalesOrdersByFulfillmentPlanIds = (state, { fulfillmentPlanIds }) => {
  const salesOrderIds = selectSalesOrderIdsByFulfillmentPlanIds(state, {
    fulfillmentPlanIds,
  });

  return selectSalesOrdersByIds(state, { salesOrderIds });
};
